/* هبة — Heba theme interactions (vanilla JS, no dependencies) */
(function () {
  "use strict";

  var money = function (cents) {
    try {
      var n = (cents / 100);
      return n.toLocaleString("ar-SA", { maximumFractionDigits: n % 1 === 0 ? 0 : 2 });
    } catch (e) {
      return (cents / 100).toFixed(0);
    }
  };
  var CURRENCY = (window.Heba && window.Heba.currencySymbol) || "ر.س";

  /* ---------- Header scroll state ---------- */
  var header = document.querySelector(".site-header");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 60) header.classList.add("scrolled");
      else header.classList.remove("scrolled");
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Mobile menu ---------- */
  var menuToggle = document.querySelector("[data-menu-toggle]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener("click", function () {
      mobileMenu.classList.toggle("open");
    });
    mobileMenu.querySelectorAll("a").forEach(function (a) {
      a.addEventListener("click", function () { mobileMenu.classList.remove("open"); });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-visible"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add("is-visible"); });
  }

  /* ---------- Smooth anchor scroll ---------- */
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = link.getAttribute("href");
      if (id.length < 2) return;
      var el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        var top = el.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: "smooth" });
      }
    });
  });

  /* ---------- Fragrance experience tabs ---------- */
  document.querySelectorAll("[data-exp]").forEach(function (root) {
    var tabs = root.querySelectorAll("[data-exp-tab]");
    var cards = root.querySelectorAll("[data-exp-card]");
    tabs.forEach(function (tab) {
      tab.addEventListener("click", function () {
        var key = tab.getAttribute("data-exp-tab");
        tabs.forEach(function (t) { t.classList.toggle("active", t === tab); });
        cards.forEach(function (c) { c.classList.toggle("active", c.getAttribute("data-exp-card") === key); });
      });
    });
  });

  /* ---------- Product gallery thumbs ---------- */
  document.querySelectorAll("[data-gallery]").forEach(function (g) {
    var main = g.querySelector("[data-gallery-main]");
    g.querySelectorAll("[data-thumb]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var src = btn.getAttribute("data-thumb");
        if (main) main.src = src;
        g.querySelectorAll("[data-thumb]").forEach(function (b) { b.classList.toggle("active", b === btn); });
      });
    });
  });

  /* ====================================================
     CART (AJAX) — works with Shopify /cart endpoints
     ==================================================== */
  var drawer = document.querySelector("[data-cart-drawer]");
  var overlay = document.getElementById("CartDrawerOverlay");
  var itemsEl = drawer && drawer.querySelector("[data-cart-items]");
  var totalEl = drawer && drawer.querySelector("[data-cart-total]");
  var countEls = document.querySelectorAll("[data-cart-count]");

  function setCount(n) {
    countEls.forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? "flex" : "none";
    });
  }

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("open");
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("open");
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = "";
  }
  if (overlay) overlay.addEventListener("click", closeDrawer);
  document.querySelectorAll("[data-cart-open]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); openDrawer(); renderCart(); });
  });
  document.querySelectorAll("[data-cart-close]").forEach(function (b) {
    b.addEventListener("click", closeDrawer);
  });

  function renderCart() {
    if (!itemsEl) return;
    fetch(window.Heba.routes.cart + ".js", { headers: { "Content-Type": "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        if (!cart.items.length) {
          itemsEl.innerHTML = '<div class="cart-empty"><p>سلتك فارغة حالياً</p></div>';
          if (totalEl) totalEl.textContent = "";
          return;
        }
        itemsEl.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image.replace(/(\.[a-zA-Z]+)(\?.*)?$/, "_160x$1") : "";
          return '' +
            '<div class="cart-line" data-key="' + it.key + '">' +
              (img ? '<img src="' + img + '" alt="' + it.product_title + '">' : '') +
              '<div class="cart-line__info">' +
                '<h4>' + it.product_title + '</h4>' +
                (it.variant_title && it.variant_title !== "Default Title" ? '<p>' + it.variant_title + '</p>' : '') +
                '<p class="cart-line__price">' + money(it.final_line_price) + ' ' + CURRENCY + '</p>' +
                '<div class="qty">' +
                  '<button data-qty-dec aria-label="نقص">−</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button data-qty-inc aria-label="زيادة">+</button>' +
                '</div>' +
              '</div>' +
              '<button data-remove aria-label="حذف" class="icon-btn" style="background:transparent;border-color:rgba(200,133,74,.3);color:var(--gold-text);width:32px;height:32px;">✕</button>' +
            '</div>';
        }).join("");
        if (totalEl) totalEl.textContent = money(cart.total_price) + " " + CURRENCY;
        bindLineEvents();
      });
  }

  function changeQty(key, qty) {
    fetch(window.Heba.routes.cartChange + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function () { renderCart(); });
  }

  function bindLineEvents() {
    itemsEl.querySelectorAll(".cart-line").forEach(function (line) {
      var key = line.getAttribute("data-key");
      var qtyEl = line.querySelector(".qty span");
      var q = parseInt(qtyEl.textContent, 10);
      var inc = line.querySelector("[data-qty-inc]");
      var dec = line.querySelector("[data-qty-dec]");
      var rem = line.querySelector("[data-remove]");
      if (inc) inc.addEventListener("click", function () { changeQty(key, q + 1); });
      if (dec) dec.addEventListener("click", function () { changeQty(key, q - 1); });
      if (rem) rem.addEventListener("click", function () { changeQty(key, 0); });
    });
  }

  /* Add to cart (forms with data-add-to-cart) */
  document.querySelectorAll("form[data-add-to-cart]").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "جارٍ الإضافة..."; }
      var fd = new FormData(form);
      fetch(window.Heba.routes.cartAdd + ".js", { method: "POST", body: fd })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) { btn.textContent = "✓ تمت الإضافة"; }
          renderCart();
          openDrawer();
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1400);
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = original; } });
    });
  });

  /* Variant selection on PDP -> resolve variant from visible options */
  document.querySelectorAll("[data-variant-root]").forEach(function (root) {
    var data = root.querySelector("[data-variant-json]");
    if (!data) return;
    var variants = JSON.parse(data.textContent);
    var idInput = root.querySelector("[data-variant-id]");
    var priceEl = root.querySelector("[data-variant-price]");
    var compareEl = root.querySelector("[data-variant-compare]");
    var submitBtn = root.querySelector('[type="submit"]');
    var optionInputs = root.querySelectorAll("[data-variant-option]");
    if (!optionInputs.length) return;

    function selectedOptions() {
      var values = [];
      optionInputs.forEach(function (inp) {
        if (inp.checked) {
          values[parseInt(inp.getAttribute("data-opt-index"), 10)] = inp.value;
        }
      });
      return values;
    }

    function update() {
      var sel = selectedOptions();
      var match = variants.filter(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = money(match.price) + " " + CURRENCY;
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = money(match.compare_at_price) + " " + CURRENCY;
          compareEl.style.display = "inline";
        } else { compareEl.style.display = "none"; }
      }
      if (submitBtn) {
        submitBtn.disabled = !match.available;
        submitBtn.textContent = match.available ? "أضف للسلة" : "نفد المخزون";
      }
    }

    optionInputs.forEach(function (inp) { inp.addEventListener("change", update); });
  });

  /* Init cart count on load */
  if (drawer) renderCart();
})();
